import { hijackFn, initDataTime, numSeparator } from "@/basic-common/util/common";
import { desensitizationDispose } from "@/basic-common/util/desensitization";
import _ from 'lodash';
/**
 * @Description: avue-crud 混入方法
 * @Date: 2024/6/17
 */
export default {
  data() {
    let that = this
    const basePermi = this.$route.path.substring(1).replaceAll('/', ':') + ':'
    const convert = basePermi.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ""))
    return {
      convert,
      openType: '',
      dialogFormStyle: '', //解决bug 记录dialog的Style
      initState: false, // 拦截首次
      form: {},
      query: {},
      queryData: {},//格式化后的query
      defaultParams: {}, // 默认查询条件（无论如何都会传，可被query覆盖）
      loading: false, // 表格 loading
      defaults: {}, // avue-crud defaults
      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 0 // 总条数
      },
      selectionList: [], // 选中列表
      data: [], // 列表数据
      cardData: {}, // 卡片信息数据
      responseData: null, // 列表相应数据集
      getTableHeightEvent: function () {
        that.$nextTick(() => {
          that.$refs.crud && that.$refs.crud.getTableHeight()
        })
      },
      customerPermission: {}
    }
  },
  created() {
    this.initSearchValue()
    this.queryAutoArrange()
  },
  mounted() {
    // 默认加载或处理
    this.CrudMixinsInit();
  },
  // keep-alive开启后的处理 清除上一次的处理
  activated() {
    process.nextTick(() => {
      this.$refs.crud && this.$refs.crud.doLayout();
    })
    if (this.option) {
      !this.option.cancelHijack && window.addEventListener("resize", this.getTableHeightEvent);
      !this.option.cancelHijack && this.$refs.crud && this.$refs.crud.getTableHeight();
    }
  },
  deactivated() {
    this.option && !this.option.cancelHijack && window.removeEventListener("resize", this.getTableHeightEvent);
  },
  computed: {
    permissionList() {
      // const convert = this.convert
      return {
        ...this.customerPermission
      }
    },
    ids() {
      return this.selectionList.map(item => item.id).join()
    },
  },
  methods: {
    CrudMixinsInit() {
      if (this.option) {
        // -- 重新编译Placeholder值 不需要删除即可 不提供参数关闭
        this.setPlaceholder();
        // -------------------------------以下方法涉及到this.$refs.crud-----------------------------------------
        if (!this.$refs.crud) return
        // -- 重写avue缩放逻辑 如果项目内无缩放功能可以删除
        this.fullScreen();
        // -- 是否需要重新计算表格以完成适配
        !this.option.cancelHijack && hijackFn(this.$refs.crud, 'getTableHeight', this.hijackerTableHeight);
        !this.option.cancelHijack && window.addEventListener("resize", this.getTableHeightEvent);
        !this.option.cancelHijack && this.getTableHeightEvent();
      }
    },
    /* =================================================== Avue回调 ==========================================================  */
    rowSave(row, done, loading) {
      this.apiConfig.add(row).then(() => {
        this.selectionClear()
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
      });
    },
    rowUpdate(row, index, done, loading) {
      this.apiConfig.update(row).then(() => {
        this.selectionClear()
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
      });
    },
    rowDel(row) {
      const that = this
      this.$confirm('确定删除选中信息？').then(() => {
        this.loading = true;
        that.apiConfig.remove(row.id).then(() => {
          this.selectionClear()
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功'
          });
        }).catch(() => {
          this.loading = false
        })
      }).catch((e) => {
        console.info(e, "-----crud-mixins line:141 -----")
      });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定删除选中信息？').then(() => {
        this.loading = true
        const request = this.apiConfig.batchRemove || this.apiConfig.remove
        request(this.ids).then(() => {
          this.selectionClear()
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.$refs.crud.toggleSelection();
        });
      })
    },
    beforeOpen(done, type) {
      this.openType = type
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {

        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data;
          done();
        });
      } else {
        done();
      }
    },
    //row-class-name回调， 添加了选中底色
    rowClass({ rowIndex }) {
      const checkboxData = this.selectionList.map((item) => item.$index)
      if (checkboxData.includes(rowIndex)) {
        return 'slecleRowColor ';
      }
    },
    searchReset() {
      this.query = {};
      this.initSearchValue()
      this.selectionClear()
      this.onLoad(this.page, this.query);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.selectionClear()
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud && this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.selectionClear()
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      if (this.initstate) {
        this.initstate = false
        return
      }
      this.queryData = this.formatParams(Object.assign({}, this.defaultParams, params, this.query))
      if (!this.apiConfig || !this.apiConfig.getList) return;
      this.loading = true;
      const requestParams = {
        ...this.queryData,
        page: page.currentPage,
        size: page.pageSize,
      }
      this.apiConfig.getList(requestParams).then(res => {
        this.responseData = res.data.data.records;
        this.page.total = res.data.data.total;
        this.responseData = initDataTime(this.responseData, this.option.column);
        this.data = numSeparator(this.responseData, this.option, 'list'); //千位符处理
        this.data = desensitizationDispose(this.responseData, 'list'); //脱敏
        if (this.initCardData) {
          // 自定义赋值卡片信息相关数据
          this.initCardData()
        } else {
          // 赋值卡片信息相关数据
          this.cardData = res.data.data
        }
        if (this.afterSearch) this.afterSearch()
        // this.selectionClear();
      }).finally(() => {
        this.loading = false;
        this.$nextTick(() => {
          if (this.option && !this.option.cancelHijack && this.$refs.crud) {
            this.$refs.crud.getTableHeight && this.$refs.crud.getTableHeight()
            this.$refs.crud.doLayout && this.$refs.crud.doLayout()
          }
        })
      })
    },
    /* ==================================================== END  ==========================================================  */
    // 将 searchValue 赋值到query中
    initSearchValue() {
      this.option.column.forEach(item => {
        if (item.searchValue) this.$set(this.query, item.prop, item.searchValue)
      })
    },
    // 统一处理生成代码的placeholder和overHidden
    setPlaceholder() {
      this.option.column.forEach((item) => {
        if (!item.placeholder) {
          if (!item.type || item.type === 'input' || item.type === 'textarea') {
            item.placeholder = '请输入';
          } else {
            item.placeholder = '请选择';
          }
          // 单独处理拼音码 可能没有考虑到所有情况 如果有误在item里添加自己的placeholder即可
          if (item.remote && item.dicUrl) {
            item.placeholder = '请检索';
          }
        }
        item.overHidden = this.validatenull(item.overHidden) ? true : item.overHidden
      })
    },
    // 自动根据查询框数量排序按钮
    queryAutoArrange() {
      if (this.option && this.option.column) {

        if (!this.option.searchMenuPosition) this.option.searchMenuPosition = 'right';
        const searchNumber = this.option.column.filter((item) => item.search) || [];
        if (this.option.searchMenuSpanSuper) {
          this.option.searchMenuSpan = this.option.searchMenuSpanSuper
          return;
        }
        const sumSpan = searchNumber.reduce((total, current) => {
          let num = total + (current.searchSpan || 6)
          if (num % 24 > 0 && num % 24 < 6) {
            num = 24 + (current.searchSpan || 6)
          }
          return num
        }, 0)
        this.option.searchMenuSpan = 24 - (sumSpan % 24)
      }
    },
    /*
      因层级过深把覆盖展开写，不采用封装的劫持
      此方法完全依赖于ref属性。 如果你的<avue-crud> 标签ref值不等于 “crud” 此方法将不奏效。
    */
    fullScreen() {
      const crud = this.$refs.crud || null
      const dialogForm = crud && crud.$refs.dialogForm
      if (dialogForm)
        dialogForm.handleFullScreen = this.hijackerFullScreen
    },
    // FullScreen 劫持者
    hijackerFullScreen() {
      this.$nextTick(() => {
        const crud = this.$refs.crud || null
        const dialogForm = crud && crud.$refs.dialogForm
        const dragDom = dialogForm.$children[0].$el.querySelector('.el-dialog');
        if (dialogForm && this.dialogFormStyle) {
          dragDom.style = this.dialogFormStyle
        }

        //====== 迁移avue源码内容 =====
        if (dialogForm.isDrawer) {
          if (dialogForm.validatenull(dialogForm.size)) {
            dialogForm.size = '100%'
          } else {
            dialogForm.size = ''
          }
        }
        if (dialogForm.fullscreen) {
          dragDom.style = this.dialogFormStyle
          dialogForm.fullscreen = false;
        } else {
          dialogForm.fullscreen = true;
          this.dialogFormStyle = _.cloneDeep(dragDom.style)
          dragDom.style = dragDom.styleName;
        }
      })
    },
    // getTableHeight 劫持者
    hijackerTableHeight() {
      let that = this
      return function () {
        that.getTableHeight()
      }
    },
    /*
      劫持avue回调并重构avue表格假适配逻辑
      此方法完全依赖于ref属性。 如果你的<avue-crud> 标签ref值不等于 “crud” 此方法将不奏效。
    */
    getTableHeight() {
      this.$nextTick(() => {
        const ThCrud = this.$refs.crud && this.$refs.crud.$refs;
        const tableRef = ThCrud && ThCrud.table;
        if (!tableRef) return

        const getPaginationHeight = (node) => {
          const el = node && typeof node.querySelector === 'function'
            ? node
            : this.$refs.crud.$el.querySelector('.avue-crud__pagination')
          if (!el) return 0
          const pagination = el.querySelector('.el-pagination')
          const hasPagination = pagination && pagination.offsetParent !== null
          el.classList && el.classList.toggle('avue-crud__pagination--empty', !hasPagination)
          if (!hasPagination) return 0
          const body = el.querySelector('.el-card__body')
          const bodyStyle = body ? window.getComputedStyle(body) : null
          const outerStyle = window.getComputedStyle(el)
          const paddingTop = bodyStyle ? parseFloat(bodyStyle.paddingTop || 0) : 0
          const paddingBottom = bodyStyle ? parseFloat(bodyStyle.paddingBottom || 0) : 0
          const marginTop = parseFloat(outerStyle.marginTop || 0)
          const marginBottom = parseFloat(outerStyle.marginBottom || 0)
          return pagination.offsetHeight + paddingTop + paddingBottom + marginTop + marginBottom
        }

        const domHeight = document.documentElement.clientHeight
        const tableTop = tableRef.$el.getBoundingClientRect().top || 0
        // 内容区域内 查询盒子/工具栏/分页
        const pageStyle = getPaginationHeight(ThCrud.tablePage && ThCrud.tablePage.$el)
        // 尾部插槽
        const crud_footer = this.$refs.crud_footer ? this.$refs.crud_footer.$el.offsetHeight : 0

        if (!this.option.height || this.option.height === 'auto') {
          const tableCalcHeight = Number(this.tableCalcHeight) || 0
          const tableBottomGap = this.validatenull(this.tableBottomGap) ? 22 : Number(this.tableBottomGap)
          const tableHeight = domHeight - tableTop - pageStyle - crud_footer - tableCalcHeight - tableBottomGap
          this.$refs.crud.tableHeight = Math.max(180, tableHeight)
        } else {
          this.$refs.crud.tableHeight = this.option.height;
        }
        this.$nextTick(() => {
          this.$refs.crud && this.$refs.crud.doLayout && this.$refs.crud.doLayout()
        })
      })
    },
    // 格式化查询条件参数(主要是将时间查询分成两个参数传到后台)
    formatParams(params) {
      const result = this.deepClone(params)
      for (let key in result) {
        // 删除空数据
        if (!result[key] && result[key] !== 0) delete result[key]
        // 数组
        if (result[key] instanceof Array) {
          // 获取 column 对应配置信息
          const obj = this.option.column.find(item => item.prop === key)
          // column 中配置 paramsKey 用于格式化（paramsKey: ['createTimeStart', 'createTimeEnd']）
          if (!this.validatenull(obj) && obj.paramsKey) {
            obj.paramsKey.forEach((item, idx) => {
              result[item] = result[key][idx]
            })
            delete result[key]
          }
        }
      }
      return result
    }
  }
}
